import React from 'react'
import {useTranslation} from "react-i18next";

import {IonButtons, IonItem, IonItemOptions, IonLabel} from "@ionic/react"

import {User as ItemType}   from "../../types/User"
import IconUser             from "../common/Icons/User"

import BadgeUserIsAdmin           from "../common/Badges/BadgeUserIsAdmin"
import BadgeUserIsYou             from "../common/Badges/BadgeUserIsYou"
import ListItemButtonDataSource   from "../common/Buttons/ListItemButtonDataSource"
import ListItemButtonKeys         from "./ListItem/ButtonKeys"
import ListItemButtonLockingSystemPermissions from "./ListItem/ButtonLockingSystemPermissions"
import ListItemButtonUserDisabled from "../common/Buttons/ListItemButtonUserDisabled"
import ListItemButtonUsers        from "./ListItem/ButtonUsers"
import ListItemOptionDelete       from "./ListItem/OptionDelete"

import {useAuth} from "../../contexts/AuthContext"

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({item}) => {

    const {userInfo: authUserInfo} = useAuth()
    const { t } = useTranslation()

    return (
        <>
            <IonItem button detail routerLink={"/users/" + item.id + "/view"} slot="start">
                <IconUser slot="start" />
                <IonLabel>
                    {item.name}
                    <p>{item.email}</p>
                </IonLabel>
                <IonButtons className="ion-hide-sm-down" slot="end">
                    {!item.isEnabled  && <ListItemButtonUserDisabled />}
                    {item.id           === authUserInfo?.user.id && <BadgeUserIsYou />}
                    {item.isAdmin  && <BadgeUserIsAdmin item={item} />}
                    {! item.isAdmin &&
                    <>
                        <ListItemButtonUsers item={item} />
                        <ListItemButtonKeys item={item} />
                        <ListItemButtonLockingSystemPermissions item={item} />
                    </>
                    }
                    <div style={{ 'minWidth': '50px' }}>
                        {item.dataSourceId !== null &&
                            <ListItemButtonDataSource itemType={t('users.title_item').toLowerCase()} />}
                    </div>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {item.options?.isDeletable && <ListItemOptionDelete item={item} />}
            </IonItemOptions>
        </>
    )
}

export default ListItem